module.exports = __webpack_public_path__ + "img/secondary_11x1_z18.9ded47ca.svg";